var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecArray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V4H0V0Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6H4V10H0V6Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12H4V16H0V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13V15H1V13H3ZM0 12V16H4V12H0Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0H16V4H12V0Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6H16V10H12V6Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12H16V16H12V12Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0H10V4H6V0Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6V6Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12H10V16H6V12Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecArray);
export default __webpack_public_path__ + "static/media/rec-array.3a1554c7130275de608fe9b2d2d16511.svg";
export { ForwardRef as ReactComponent };